import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import {
  MutationWithArrayInput,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  HRService,
  //caseManagementUrl,
  setupManagementUrl,
} from "../../../config";

import DynamicForm from "../../../data/Axios/DynamicForm";
import { allCasesView } from "../../../data/Axios/queries";
import {
  allDisbursementType,
  imprestApplications,
  imprestApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { staffClaimsFields } from "../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { fetchJson } from "../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = HRService.uri;

const StaffClaimApplicationForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [imprestApplicationsdata, setImprestApplications] = useState([]);
  const [disbursementTypes, setDisbursementTypes] = useState([]);
  const [cases, setCases] = useState([]);
const [showCases, setShowCases] = useState(
  props.data ? props.data.caseRelated === 1 : false
);

  const [loading, setLoading] = useState(true);

  const initialValues = {
    applicationId: props.data ? props.data.ApplicationId : "",
    disbursementTypeId: props.data ? props.data.DisbursementTypeId : 0,
    totalAmount: props.data ? props.data.TotalAmount : "",
    title: props.data ? props.data.Title : "",
    description: props.data ? props.data.Description : "",
    caseRelated: props.data ? props.data.CaseRelated : false,
    caseId: props.data ? props.data.CaseId : "",
    userId: userId,
    companyId: companyId,
  };

  async function fetchData() {
    try {
      const imprestData = await fetchJson({
        objectName: "imprestApplicationsByUser",
        baseUrl: HRService.uri
    });
      const disbursementData = await fetchJson({
        objectName: "allDisbursementTypes",
        baseUrl: HRService.uri
    });
      //const casesData = await graphqlQuery(allCasesView, caseManagementUrl.uri);

      if (imprestData) setImprestApplications(JSON.parse(imprestData.results) || []);
      if (disbursementData) setDisbursementTypes(JSON.parse(disbursementData.results) || []);
     // if (casesData) setCases(casesData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let isMounted = true;
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const imprestApplicationOptions = imprestApplicationsdata
    ? imprestApplicationsdata.map((app) => ({
        value: app.Id,
        label: app.Title,
      }))
    : [];

  const disbursementTypeOptions = disbursementTypes
    ? disbursementTypes.map((type) => ({
        value: type.Id,
        label: type.Type,
      }))
    : [];

  // const caseOptions = cases
  //   ? cases.map((caseItem) => ({
  //       value: caseItem.id,
  //       label: caseItem.title,
  //     }))
  //   : [];
  const handleFieldChange = async (field, value) => {
    if (field.name === "caseRelated") {
      if (value === true) {
        setShowCases(true);
        }
        else{    setShowCases(false);}
  
    }
  };
  const fields = [
    {
      name: "applicationId",
      label: "Application",
      type: "select",
      options: imprestApplicationOptions.map((app) => ({
        value: app.value,
        label: app.label,
      })),
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "disbursementTypeId",
      label: "Disbursement Type",
      type: "select",
      options: disbursementTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      required: false,
      gridColumn: "span 2",
    },
    ...staffClaimsFields,
    // ...(showCases
    //   ? [
    //       {
    //         name: "caseId",
    //         label: "Cases",
    //         type: "select",
    //         options: caseOptions.map((caseItem) => ({
    //           value: caseItem.value,
    //           label: caseItem.label,
    //         })),
    //         required: false,
    //         gridColumn: "span 2",
    //       },
    //     ]
    //   : []),
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        disbursementTypeId,
        title,
        applicationId,
        description,

      } = values;
      const mutationData = {
        applicationId,
        disbursementTypeId,
        caseRelated: values.caseRelated === 1 ? true:false,
        title,
        description,
        userId: userId,     
        //caseId: values.caseId?values.caseId:null,
      };
      if (props.isEditing) {
        mutationData.id = props.data.Id;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing
          ? "updateStaffClaimApplication"
          : "createStaffClaimApplication",
        mutationData,
        "staffClaim",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Staff claim application created successfully.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onFieldChange={handleFieldChange}
      onSubmit={handleSubmit}
      title={
        props.isEditing
          ? "Update Staff Claim Application"
          : "Create Staff Claim Application"
      }
      subtitle={
        props.isEditing
          ? "Fill out the form below to update staff claim application."
          : "Fill out the form below to apply for a staff claim application."
      }
    />
  );
};

export default StaffClaimApplicationForm;
